var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterControlWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.647,
    height: 15,
    viewBox: "0 0 17.647 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 117",
    d: "M14.353 10.765H3.882a.882.882 0 1 1 0-1.765h10.471a.882.882 0 1 1 0 1.765z",
    transform: "translate(-3 -6.794)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 118",
    d: "M17.559 12.676a3.088 3.088 0 1 1 3.088-3.088 3.088 3.088 0 0 1-3.088 3.088zm0-4.412a1.324 1.324 0 1 0 1.324 1.324 1.324 1.324 0 0 0-1.324-1.323zm.735 11.029H7.824c-.487 0 0-.6 0-.6s-.487-1.163 0-1.163h10.47a.882.882 0 0 1 0 1.765z",
    transform: "translate(-3 -6.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M10.088 22.676a3.088 3.088 0 1 1 3.088-3.088 3.088 3.088 0 0 1-3.088 3.088zm0-4.412a1.324 1.324 0 1 0 1.324 1.324 1.324 1.324 0 0 0-1.324-1.323z",
    transform: "translate(-7 -7.676)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterControlWhite);
export default __webpack_public_path__ + "static/media/filter-control-white.f2da7ddd4c29805cd1538b4311130543.svg";
export { ForwardRef as ReactComponent };